import { render } from "./op_items.vue?vue&type=template&id=5343d24e"
import script from "./op_items.vue?vue&type=script&lang=js"
export * from "./op_items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__